import { html, mount } from '../../core/html.js';
import { get, session } from '../../core/api.js';
import { barChart, statusBadge } from '../../core/ui.js';
import { rm, fmtDateShort } from '../../core/format.js';
import { t } from '../../core/i18n.js';
import { workspace } from '../shared/layout.js';

export function walletStrip(s) {
  return html`<div class="wallet-strip" aria-label="${t('wallet.summary')}">
    <div><div class="l">${t('wallet.total_earned')}</div><div class="v">${rm(s.total_earnings_minor)}</div></div>
    <div><div class="l">${t('wallet.pending')}</div><div class="v">${rm(s.pending_earnings_minor)}</div></div>
    <div class="avail"><div class="l">${t('wallet.available')}</div><div class="v">${rm(s.available_earnings_minor)}</div></div>
    <div><div class="l">${t('wallet.withdrawal_pending')}</div><div class="v">${rm(s.withdrawal_pending_minor)}</div></div>
    <div><div class="l">${t('wallet.withdrawn')}</div><div class="v">${rm(s.total_withdrawn_minor)}</div></div></div>`;
}

export async function render(main) {
  const body = workspace(main, 'host');
  const [dash, bookings] = await Promise.all([get('/api/host/dashboard'), get('/api/bookings?role=host&limit=50')]);
  const host = session.me.host;
  const s = dash.summary;
  const todo = [];
  if (host.verification_status !== 'VERIFIED') todo.push(html`<li><a href="#/host/settings">${t(host.verification_status === 'PENDING' ? 'hostdash.todo_verify_pending' : 'hostdash.todo_verify')}</a></li>`);
  if (!host.bank) todo.push(html`<li><a href="#/host/settings">${t('hostdash.todo_bank')}</a></li>`);
  if (!s.properties) todo.push(html`<li><a href="#/host/properties/new">${t('hostdash.todo_listing')}</a></li>`);
  const upcoming = bookings.filter((b) => ['CONFIRMED', 'CHECKED_IN'].includes(b.status)).sort((a, b) => (a.check_in < b.check_in ? -1 : 1)).slice(0, 5);
  mount(body, html`
    <div class="spread"><h1 style="margin:0">${t('hostdash.welcome')} <span data-ugc>${host.display_name}</span></h1><a class="btn btn-primary btn-sm" href="#/host/properties/new">${t('hprops.add')}</a></div>
    ${todo.length ? html`<div class="panel soft" style="margin-top:14px"><b>${t('hostdash.todo_title')}</b><ul style="margin:6px 0 0">${todo}</ul></div>` : ''}
    <div style="margin-top:16px">${walletStrip(s)}</div>
    <div class="kpis" style="margin-top:14px">
      <div class="kpi"><div class="l">${t('hostdash.gross')}</div><div class="v">${rm(s.gross_revenue_minor)}</div></div>
      <div class="kpi"><div class="l">${t('wallet.platform_fee')}</div><div class="v">${rm(s.platform_fees_minor)}</div></div>
      <div class="kpi lead"><div class="l">${t('hostdash.net')}</div><div class="v">${rm(s.net_earnings_minor)}</div></div>
      <div class="kpi"><div class="l">${t('hostdash.rating')}</div><div class="v">${s.rating_avg || '–'}</div></div>
    </div>
    <h2 style="margin-top:22px">${t('hostdash.upcoming')}</h2>
    ${upcoming.length ? html`<div class="list">${upcoming.map((b) => html`<a class="item" href="#/bookings/${b.id}"><span class="grow"><b data-ugc>${b.snapshot.guest_information.name}</b><div class="small muted"><span data-ugc>${b.snapshot.property_name}</span>, ${fmtDateShort(b.check_in)} – ${fmtDateShort(b.check_out)}</div></span>${statusBadge(b.status, 'booking')}</a>`)}</div>` : html`<p class="muted">${t('hostdash.no_upcoming')}</p>`}
    <div class="charts" style="margin-top:22px">
      ${barChart(t('hostdash.chart_earnings'), dash.charts.revenue, { money: true })}
      ${barChart(t('hostdash.chart_bookings'), dash.charts.bookings)}
      ${barChart(t('hostdash.chart_occupancy'), dash.charts.occupancy, { suffix: '%' })}
      ${barChart(t('hostdash.chart_rating'), dash.charts.reviews, { suffix: '★' })}
    </div>`);
}
